import { theme, Button } from '@dasa-health/components-react'
import styled from 'styled-components'

export const ButtonFinish = styled(Button)`
    z-index: 1000;
    background-color: ${theme.colors.white} !important;
    color: ${theme.colors.primary} !important;
    width: 100% !important;
    margin-top: auto !important;

    @media (min-width: ${theme.breakpoints[0]}) {
        // tablet
        margin-top: 96px !important;
        width: 360px !important;
    }

    @media (min-width: ${theme.breakpoints[2]}) {
        // desktop
        margin-top: 64px !important;
        width: 448px !important;
    }
`
export const ContainerLoading = styled.div`
    margin-top: auto;

    @media (min-width: ${theme.breakpoints[0]}) {
        // tablet
        margin-top: 0px;
    }
`
